import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Server_URL } from 'src/environments/environment';
import { environment } from 'src/environments/environment.prod';


@Injectable({
  providedIn: 'root'
})
export class DonationCategoryService {
  public Data = new BehaviorSubject(null)
  
  constructor(private _HttpClient:HttpClient) { }

  GetDonationCategory():Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/DonationCategory/Get`);
  }

  DeleteDonationCategory(id):Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/DonationCategory/Delete?id=${id}`);
  }

  CreateDonationCategory(data):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/DonationCategory/Create`,data);
  }
  UpdateDonationCategory(data):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/DonationCategory/Update`,data)
  }
}
